type RouteCache = Record<string, boolean>;

// Cleared on window refresh, unique to each window
const cachedIsCompactValues: RouteCache = {};
let previousRouteKey: string | undefined;

/**
 * Retrieves (if exists) a cached `isCompact` value
 * @returns `true` or `false` if there is a cached value, `undefined` otherwise
 */
export function getCachedIsCompactValue(key: string): boolean | undefined {
	return cachedIsCompactValues[key];
}

/**
 * writes to a global variable that persists until page is refreshed
 * @param isCompactValue a `boolean` value of `isCompact`
 */
export function setCachedIsCompactValue(isCompactValue: boolean, key: string): void {
	cachedIsCompactValues[key] = isCompactValue;
}

/**
 * @param currentRouteKey the key which to check if the route has changed
 */
export function invalidateCacheIfRouteChanged(currentRouteKey: string): void {
	// If we navigate away from the route we can't assume that the cached value will stay valid when we come back
	if (currentRouteKey !== previousRouteKey) {
		previousRouteKey = currentRouteKey;
		delete cachedIsCompactValues[previousRouteKey];
	}
}
